import * as React from "react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";

export interface StatCardProps {
  /** Icon rendered inside the colored box, e.g. <Wrench className="text-2xl" /> */
  icon: React.ReactNode;
  /** Small label next to the icon, e.g. "Revenue" */
  label: string;
  /** The headline value, e.g. "KES 12,000" or 42 */
  value: React.ReactNode;
  /** Caption under the value, e.g. "Last 30 Days Turnover" */
  title?: string;
  /** Optional content rendered below a separator, e.g. a per-method breakdown */
  footer?: React.ReactNode;
  iconClassName?: string;
  className?: string;
}

export function StatCard({
  icon,
  label,
  value,
  title,
  footer,
  iconClassName,
  className,
}: StatCardProps) {
  return (
    <Card
      className={cn(
        "rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 overflow-hidden",
        className
      )}
    >
      <CardHeader className="flex-row items-center gap-2 space-y-0 p-6 pb-4">
        <div
          className={cn(
            "grid h-10 w-10 place-content-center rounded-lg bg-gradient-to-r from-accent to-accent shadow-lg",
            iconClassName
          )}
        >
          {icon}
        </div>
        <span className="text-sm font-semibold">{label}</span>
      </CardHeader>
      <CardContent className="space-y-4 p-6 pt-0">
        <div className="space-y-2">
          <h3 className="text-lg font-semibold">{value}</h3>
          {title && <p className="text-sm text-muted-foreground">{title}</p>}
        </div>
        {footer && (
          <>
            <Separator />
            {footer}
          </>
        )}
      </CardContent>
    </Card>
  );
}
